import { atom } from "nanostores";

export interface NavigationState {
  isNavigating: boolean;
  currentTab: string | null;
  targetTab: string | null;
}

export const navigationStore = atom<NavigationState>({
  isNavigating: false,
  currentTab: null,
  targetTab: null,
});

export const startNavigation = (targetTab: string) => {
  navigationStore.set({
    ...navigationStore.get(),
    isNavigating: true,
    targetTab,
  });
};

export const endNavigation = () => {
  const current = navigationStore.get();
  navigationStore.set({
    isNavigating: false,
    currentTab: current.targetTab,
    targetTab: null,
  });
};
